import { MaintenancePageResponse } from 'app/modules/settings/infrastructure/dto/response/MaintenancePageResponse';
import { MaintenancePage } from 'app/modules/settings/domain/entity/MaintenancePage';
import { MaintenancePageName, MaintenancePageNameValue } from 'app/modules/settings/domain/valueObject/MaintenancePageName';
import { MaintenancePageOrigin } from 'app/modules/settings/domain/valueObject/MaintenancePageOrigin';
import { MaintenancePageId } from 'app/modules/settings/domain/valueObject/MaintenancePageId';
import { TranslationArrayMapper } from 'app/modules/settings/infrastructure/repository/api/dataMapper/TranslationArrayMapper';

export class MaintenancePageMapper {

    private static _fromOriginToPageName(origin: number): MaintenancePageName {
        // origin 0 = EUROPA, origin 1 = USA
        switch (origin) {
            case 0:
                return new MaintenancePageName(MaintenancePageNameValue.EUROPA);
            case 1:
                return new MaintenancePageName(MaintenancePageNameValue.USA);
            default:
                throw new Error('Invalid MaintenancePage Origin');
        }
    }

    public static toDomain(
        maintenancePageResponse: MaintenancePageResponse,
        inMaintenance: boolean = false,
    ):MaintenancePage {
        return new MaintenancePage(
            new MaintenancePageId(maintenancePageResponse.id),
            new MaintenancePageOrigin(maintenancePageResponse.origin),
            this._fromOriginToPageName(maintenancePageResponse.origin),
            TranslationArrayMapper.toDomain(maintenancePageResponse.translations),
            inMaintenance,
        );

    }

}
